import React from 'react';
import { ConfirmDialog } from '../../../../components/confirm-dialog';
import { LessonOccupancyDto } from '../../../../api-service/clients';
import { formatDate } from '../../../../utilities';

const maxListedLessons = 3;

interface ICourseCapacityWarningDialogProps {
  lessons: LessonOccupancyDto[];
  isLoading: boolean;
  onConfirmClick: () => void;
  onCancelClick: () => void;
}

export function CourseCapacityWarningDialog({ lessons, isLoading, onConfirmClick, onCancelClick }: ICourseCapacityWarningDialogProps) {
  const listedLessons = lessons.slice(0, maxListedLessons);
  const remainingLessons = lessons.length - listedLessons.length;

  return (
    <ConfirmDialog
      title="Ingen ledige pladser"
      type="warning"
      open
      onConfirmClick={onConfirmClick}
      onCancelClick={onCancelClick}
      confirmButtonText="Ja, fortsæt"
      cancelButtonText="Afbryd"
      cancelIsPrimary={false}
      isLoading={isLoading}
    >
      <p>Der er ikke flere ledige pladser på holdet på flg. lektioner. Vil du fortsætte?</p>
      <ul>
        {listedLessons.map(lesson => (
          <li key={lesson.lessonId}>{`${formatDate(lesson.beginAt)} (${lesson.occupiedSeats} af ${lesson.capacity} ${lesson.capacity === 1 ? 'plads' : 'pladser'} brugt)`}</li>
        ))}
      </ul>
      {remainingLessons > 0 && (
        <p>{remainingLessons === 1 ? 'Derudover er 1 lektion mere uden ledige pladser.' : `Derudover er ${remainingLessons} lektioner mere uden ledige pladser.`}</p>
      )}
    </ConfirmDialog>
  );
}
